import { LinkType } from '../../../components'
import { useLocalizedLinks } from '../../../hooks'
import { MainContentSection } from './main-content-section'
import { SectionLinkGroupProps } from './main-content-section-link-group'

export const MainContentLinks = () => {
  const links = useLocalizedLinks()

  const sectionLinkGroups = links.reduce<SectionLinkGroupProps[]>(
    (previousValue, currentValue, currentIndex) => {
      const { header, ...link } = currentValue
      const linkItem = {
        id: `important-link-${currentIndex}`,
        important: link.important,
        lineText: link.label,
        lineUrl: link.value,
        type: LinkType.BASIC
      }

      const linkGroupProps = previousValue.find(
        (linkGroup) => linkGroup.lineHeader === header
      )
      if (!linkGroupProps) {
        previousValue.push({ lineHeader: header, linkItems: [linkItem] })
      } else {
        linkGroupProps.linkItems.push(linkItem)
      }
      return previousValue
    },
    []
  )

  return (
    <MainContentSection
      headerPrimaryId="pages.frontPage.sections.importantLinks.label"
      id="links"
      noSectionItemsMessageId="pages.frontPage.sections.importantLinks.emptyLinks"
      sectionLinkGroups={sectionLinkGroups}
    />
  )
}
